<template>
    <div>
        This is rooms user interface
    </div>
</template>

<script>
  export default {
    name: 'Rooms',
  };
</script>

<style scoped>

</style>